<script setup>
import {computed, getCurrentInstance, onMounted, reactive, ref, watch} from "vue";
import {salesListsApi} from "@/api/forsales_index";
import axios from "axios";
import LoadingIcon from "@/components/LoadingIcon.vue";

const instance = getCurrentInstance()

const isLoading = ref(false)

const data = reactive({
  filtered_no: 0, // 實際過符合過慮條件的 companies 數量
  items: [],      // the companies data list (不大於 100 筆)

  sub_category_maps: {},

  // bind for the v-for check control
      categories_checked: {},
  sub_categories_checked: {},

  // categories_checked_ids from categories_checked
  categories_checked_ids: computed(() => {
    return Object.keys( data.categories_checked).filter(
        key => data.categories_checked[ key])
  }),

  // sub_categories_checked_ids from categories_checked
  sub_categories_checked_ids: computed(() => {
    return Object.keys( data.sub_categories_checked).filter(
        key => data.sub_categories_checked[ key])
  })
})

let records_all_ids = []

let sales_list_dict = [ ]
// [
//   { "name": "list_1", "id":1},
//   { "name": "list_3", "id":3},
// ]

let sales_list_id_import = 0
const companies_no_import = ref(0)
watch( companies_no_import, ( new_val, old_val) =>
{
  let msg = instance.proxy.$t( "company_db.alert_msg") + " " + data.filtered_no
  if( new_val > data.filtered_no) {
    companies_no_import.value = old_val
    import_msg.value = msg
  }
})

let     categories_dict = { }
let sub_categories_dict = { }

let     categories_names = { }
let sub_categories_names = { }

let     categories_count = { }
let sub_categories_count = { }

let categories_len = 0

function get_categories_names(list_ids) {
  let str_names = ""
  for( let i in list_ids)
  {
    let ii = parseInt( list_ids[ i])
    str_names += ( "- " + categories_names[ ii] + "<br>")
  }
  return str_names
}

const checked_counter = async () => {
  console.log( `===>     categories_checked:`, data.categories_checked_ids)
  console.log( "===> sub_categories_checked:", data.sub_categories_checked_ids)
}

// 根據 categories_checked_ids(主業界) 向 Backend 查詢所屬的 子業界 ids,
const reload_sub_category_maps = async () =>
{
  // 如果 categories_checked_ids(主業界) 為空，就不需要查詢了
  if( data.categories_checked_ids.length === 0 ) {
    data.sub_category_maps = {}
    return
  }

  // 送出已選擇的 categories id list: categories_checked_ids
  const formData = new FormData()
  formData.append( "categories_checked_ids", data.categories_checked_ids)

  // 返回值儲放在 sub_category_maps 供 Modal 驅動下半部的 sub_categories 顯示
  const resp = await axios.post( `forsales/sub_category_maps`, formData)
  data.sub_category_maps = resp.data

  console.log( "**** sub_category_maps:", data.sub_category_maps)
}

// 根據 sub_category_maps 來設定 sub_categories_checked 為 true or false
const set_sub_categories_checked = async ( cate_id, is_checked) =>
{
  let list_of_sub_cate_ids = data.sub_category_maps[ cate_id]
  console.log( "===> list_of_sub_cate_ids:", list_of_sub_cate_ids)
  for( let i in list_of_sub_cate_ids ) {
    let sub_cate_id = list_of_sub_cate_ids[ i]
    // console.log( "\tsub_cate_id:", sub_cate_id)
    data.sub_categories_checked[sub_cate_id] = is_checked
  }
}

// 當用戶點選【主業界】時
const categories_checked_change = async( cate_id) =>
{
  let checked_value = data.categories_checked[cate_id]
  console.log("=======> ", cate_id, "to", checked_value)

  if (checked_value) // user checked one(選擇)
  {
    await reload_sub_category_maps()
    await set_sub_categories_checked( cate_id, checked_value)
  }
  else // user un_checked one(取消)
  {
    await set_sub_categories_checked( cate_id, checked_value)
    await reload_sub_category_maps()
  }

  await checked_counter()
}

// 當用戶點選【子業界】時
const sub_categories_checked_change = async( ) =>
{
  await checked_counter()
}

const prefecture_all = [
  "北海道", "青森県", "岩手県", "宮城県", "秋田県", "山形県", "福島県", "茨城県"
  , "栃木県", "群馬県", "埼玉県", "千葉県", "東京都", "神奈川県", "新潟県", "富山県"
  , "石川県", "福井県", "山梨県", "長野県", "岐阜県", "静岡県", "愛知県", "三重県"
  , "滋賀県", "京都府", "大阪府", "兵庫県", "奈良県", "和歌山県", "鳥取県", "島根県"
  , "岡山県", "広島県", "山口県", "徳島県", "香川県", "愛媛県", "高知県", "福岡県"
  , "佐賀県", "長崎県", "熊本県", "大分県", "宮崎県", "鹿児島県", "沖縄県"
]
const prefecture_checked = { }
//const prefecture_len = prefecture_all.length

const show_categories_modal = ref(false);
const categories_modal_close = async () =>
{
  await checked_counter()

  filter_categories     = data.categories_checked_ids
  filter_sub_categories = data.sub_categories_checked_ids

  categories_view = ""
  for( let i in filter_categories)
  {
    let cate_id = filter_categories[i]
    console.log( "cate_id:", cate_id, categories_names[cate_id])
    categories_view += ( categories_names[cate_id] + ",")
  }
  for( let i in filter_sub_categories)
  {
    let sub_cate_id = filter_sub_categories[i]
    console.log( "sub_cate_id:", sub_cate_id, categories_names[sub_cate_id])
    categories_view += ( sub_categories_names[sub_cate_id] + ",")
  }
  categories_view = categories_view.slice(0, -1)

  show_categories_modal.value = false
}

const show_prefecture_modal = ref(false);
const prefecture_modal_close = async () =>
{
  // prefecture_checked ==> filter_prefecture
  let ff = ""
  for( let i in prefecture_checked)
    if( prefecture_checked[i])
      ff += ( i + ",")

  ff = ff.slice(0, -1)    // 去掉最後的逗號
  filter_prefecture = ff

  // close the modal
  show_prefecture_modal.value = false
}

const import_msg = ref("")
const show_import_modal = ref(false);
const import_modal_begin = async () =>
{
  isLoading.value = true

  console.log( "sales_list_id_import:", sales_list_id_import)
  console.log( "companies_no_import:", companies_no_import.value)

  let company_ids = records_all_ids.slice( 0, companies_no_import.value)
  console.log( "==> company_ids:", company_ids)

  const formData = new FormData()
  formData.append( "company_ids", company_ids)

  let resp = await axios.post(
      `/forsales/sales_lists/${sales_list_id_import}/sales_lists_details/import`,
      formData
  )

  let inserted = resp.data.inserted
  let insert_fail = resp.data.insert_fail

  console.log( "匯入成功:", inserted)
  console.log( "匯入失敗:", insert_fail)

  let mm_1 = instance.proxy.$t( "company_db.inserted")
  let mm_2 = instance.proxy.$t( "company_db.insert_fail")
  // import_msg.value = `匯入成功:${inserted.length} / 匯入失敗:${insert_fail.length}`
  import_msg.value = `${mm_1}:${inserted.length} / ${mm_2}:${insert_fail.length}`

  isLoading.value = false
}

// a.業界: categories
let filter_categories = []
let filter_sub_categories = []

let categories_view = ""  // 用於顯示在 html/input 中的內容

// b.都道府県: prefecture
let filter_prefecture = ""

// c.資本金: capital_stock
let filter_capital_stock_min = -1
let filter_capital_stock_max = -1

// d.売上高: amount_sales
let filter_amount_sales_min = -1
let filter_amount_sales_max = -1

// e.設立年月日: established_year_month
let filter_established_year_month_min = "*"
let filter_established_year_month_max = "*"

// f.従業員数: employee_number
let filter_employee_number_min = -1
let filter_employee_number_max = -1

// todo: g.事業所数, h.店鋪数 是否要顯示在列表中？

// g.事業所数: offices_number
let filter_offices_number_min = -1
let filter_offices_number_max = -1

// h.店鋪数: stores_number
let filter_stores_number_min = -1
let filter_stores_number_max = -1

// i.上場種別: stock_market
let filter_stock_market = "*"

const reload_sales_list = async () => {
  const resp = await salesListsApi.getAll();
  let salesList = resp.data;

  for (let i in salesList) {
    let id = salesList[i].id
    let name = salesList[i].list_name
    console.log("====> salesList:", name, id)

    sales_list_dict.push({"name": name, "id": id})
  }

  sales_list_id_import =sales_list_dict[0].id
}

const reload_categories = async () =>
{
  const resp_0 = await axios.get( `forsales/categories_map_count`)
  categories_count = resp_0.data

  const resp_1 = await axios.get( `forsales/sub_categories_map_count`)
  sub_categories_count = resp_1.data

  // ==== 載入 categories ====

  const resp = await axios.get( `forsales/categories`)
  categories_dict = resp.data
  categories_len = resp.data.length

  for (let i = 0; i < categories_len; i++) {
    let id = categories_dict[i]["id"]
    categories_names[ id] = resp.data[i]["name"]
    data.categories_checked[ id] = false
  }

  console.log( "*** categories_count:", categories_count)
  console.log( "*** categories_dict:", categories_dict)
  console.log( "*** categories_names:", categories_names)
  console.log( "*** categories_checked:", data.categories_checked)
  console.log( "*** categories_len:", categories_len)

  // ==== 載入 sub_categories ====

  const resp2 = await axios.get( `forsales/sub_categories`)
  sub_categories_dict = resp2.data

  for (let i in sub_categories_dict) {
    let id = sub_categories_dict[i]["id"]
    sub_categories_names[ id] = sub_categories_dict[i]["name"]
    data.sub_categories_checked[ id] = false
  }

  console.log( "*** sub_categories_dict:", sub_categories_dict)
  console.log( "*** sub_categories_names:", sub_categories_names)
  console.log( "*** sub_categories_checked:", data.sub_categories_checked)
}

const reload_data = async () =>
{
  const formData = new FormData()

  // a.業界: categories

  // console.log( "filter_categories:", filter_categories)
  // console.log( "filter_sub_categories:", filter_sub_categories)

  let str_filter_categories = "*"
  if( filter_categories.length !== 0)
    str_filter_categories = filter_categories.toString()
  console.log( "str_filter_categories:", str_filter_categories)
  formData.append( "categories", str_filter_categories);

  let str_filter_sub_categories = "*"
  if( filter_sub_categories.length !== 0)
    str_filter_sub_categories = filter_sub_categories.toString()
  console.log( "str_filter_sub_categories:", str_filter_sub_categories)
  formData.append( "sub_categories", str_filter_sub_categories);

  // b.都道府県: prefecture
  // console.log( "* filter_prefecture:", filter_prefecture)
  let str_filter_prefecture = "*"
  if( filter_prefecture !== "")
    str_filter_prefecture = filter_prefecture.toString()
  console.log( "* str_filter_prefecture:", str_filter_prefecture)
  formData.append( "prefecture", str_filter_prefecture);

  // c.資本金: capital_stock
  formData.append("capital_stock_min", filter_capital_stock_min);
  formData.append("capital_stock_max", filter_capital_stock_max);

  // d.売上高: amount_sales
  formData.append("amount_sales_min", filter_amount_sales_min);
  formData.append("amount_sales_max", filter_amount_sales_max);

  // e.設立年月日: established_year_month
  formData.append("established_year_month_min", filter_established_year_month_min);
  formData.append("established_year_month_max", filter_established_year_month_max);

  // f.従業員数: employee_number
  formData.append("employee_number_min", filter_employee_number_min);
  formData.append("employee_number_max", filter_employee_number_max);

  // g.事業所数: offices_number
  formData.append("offices_number_min", filter_offices_number_min);
  formData.append("offices_number_max", filter_offices_number_max);

  // h.店鋪数: stores_number
  formData.append("stores_number_min", filter_stores_number_min);
  formData.append("stores_number_max", filter_stores_number_max);

  // i.上場種別: stock_market
  formData.append("stock_market", filter_stock_market);

  const resp = await salesListsApi.get_companies_filter(formData)

  data.items       = resp.data.records_100
  data.filtered_no = resp.data.no
  records_all_ids  = resp.data.records_all_ids

  console.log( "filtered_no:", data.filtered_no)
  console.log( "records_all_ids:", records_all_ids)
}

const open_import_modal = async () =>
{
  companies_no_import.value = data.filtered_no

  import_msg.value = ""
  show_import_modal.value = true
}

const pure_int = (par_value) => {
  let val = par_value

  while (val.indexOf(" ") !== -1)
    val = val.replace(" ", "")

  while (val.indexOf(",") !== -1)
    val = val.replace(",", "")

  if (parseInt(val))
    return parseInt(val)

  return -1
}

const parse_date = (par_date) => {
  let val = par_date
  val = new Date(val.trim())

  if (val.toString() === "Invalid Date")
    return "*"
  else {
    let year = val.getFullYear()
    let month = val.getMonth() + 1
    let day = val.getDate()
    console.log(year, month, day)
    return [year, month, day].join('-')
  }
}

onMounted(async () =>
{
  // prepare prefecture_checked
  for( let i in prefecture_all) {
    let p = prefecture_all[i]
    // console.log( p)
    prefecture_checked[ p] = false
  }
  console.log( "prefecture_checked:", prefecture_all.length, prefecture_checked)

  await reload_categories()
  await reload_data()
  await reload_sales_list()

  // show_prefecture_modal.value = true
  // show_import_modal.value = true
})

//    a.業界: 不使用 @change 來監聽
// b.都道府県: 不使用 @change 來監聽

// c.資本金:
const capital_stock_min_changed = async (e) => {
  filter_capital_stock_min = pure_int(e.target.value)
  console.log("filter_capital_stock_min:", filter_capital_stock_min)
}
const capital_stock_max_changed = async (e) => {
  filter_capital_stock_max = pure_int(e.target.value)
  console.log("filter_capital_stock_max:", filter_capital_stock_max)
}

// d.売上高:
const amount_sales_min_changed = async (e) => {
  filter_amount_sales_min = pure_int(e.target.value)
  console.log("filter_amount_sales_min:", filter_amount_sales_min)
}
const amount_sales_max_changed = async (e) => {
  filter_amount_sales_max = pure_int(e.target.value)
  console.log("filter_amount_sales_min:", filter_amount_sales_max)
}

// e.設立年月日: established_year_month
const established_year_month_min_changed = async (e) => {
  filter_established_year_month_min = parse_date(e.target.value)
  console.log("filter_established_year_month_min:",
      filter_established_year_month_min)
}
const established_year_month_max_changed = async (e) => {
  filter_established_year_month_max = parse_date(e.target.value)
  console.log("filter_established_year_month_max:",
      filter_established_year_month_max)
}

// f.従業員数:
const employee_number_min_changed = async (e) => {
  filter_employee_number_min = pure_int(e.target.value)
  console.log("filter_employee_number_min:", filter_employee_number_min)
}
const employee_number_max_changed = async (e) => {
  filter_employee_number_max = pure_int(e.target.value)
  console.log("filter_employee_number_max:", filter_employee_number_max)
}

// g.事業所数: offices_number
const offices_number_min_changed = async (e) => {
  filter_offices_number_min = pure_int(e.target.value)
  console.log("filter_offices_number_min:", filter_offices_number_min)
}
const offices_number_max_changed = async (e) => {
  filter_offices_number_max = pure_int(e.target.value)
  console.log("filter_offices_number_max:", filter_offices_number_max)
}

// h.店鋪数: stores_number
const stores_number_min_changed = async (e) => {
  filter_stores_number_min = pure_int(e.target.value)
  console.log("filter_stores_number_min:", filter_stores_number_min)
}
const stores_number_max_changed = async (e) => {
  filter_stores_number_max = pure_int(e.target.value)
  console.log("filter_stores_number_max:", filter_stores_number_max)
}

// i.上場種別:
const stock_market_changed = async (e) => {
  filter_stock_market = e.target.value
  console.log("filter_stock_market:", filter_stock_market)
}

// for <td> view the large number
function f_int(number) {
  if (number)
    return new Intl.NumberFormat('en-US').format(number);
  return ""
}

const item_detail = (item) => {
  console.log("item detail:", item)
}

// for modal drag...

const style = ref({
  top: '100px',
  left: '100px',
  position: 'absolute',
  // border: '1px solid #ccc',
  backgroundColor: 'white',
  padding: '20px',
  // cursor: 'move',
});

const startPosition = ref({ x: 0, y: 0 });
const dragging = ref(false);

const startDrag = (event) => {
  dragging.value = true;
  startPosition.value = { x: event.clientX, y: event.clientY };
  document.addEventListener('mousemove', moveDrag);
  document.addEventListener('mouseup', endDrag);
};

const moveDrag = (event) => {
  if (dragging.value) {
    const dx = event.clientX - startPosition.value.x;
    const dy = event.clientY - startPosition.value.y;
    style.value.left = `${parseInt(style.value.left) + dx}px`;
    style.value.top = `${parseInt(style.value.top) + dy}px`;
    startPosition.value = { x: event.clientX, y: event.clientY };
  }
};

const endDrag = () => {
  dragging.value = false;
  document.removeEventListener('mousemove', moveDrag);
  document.removeEventListener('mouseup', endDrag);
};

</script>

<template>
  <LoadingIcon :is-loading="isLoading"></LoadingIcon>

  <!-- categories_modal -->
  <div v-if="show_categories_modal" class="modal-categories"
  :style="style" @mousedown="startDrag">

    <div class="modal-content">
      <div class="modal-header">
        <div class="row" style="margin-top: 20px">
          <h3>{{$t( "company_db.categories_title")}}</h3>
        </div>
      </div>

      <!-- categories select table-->
      <div class="row" style="margin-top: 20px">
        <div class="grid-container">

          <div v-for="( i, index) in categories_dict" :key="index" class="grid-item">
            <div class="flex-container">

              <div class="left">
                <input type="checkbox" style="margin-left: 20px;margin-right: 5px"
                v-model="data.categories_checked[i.id]"
                @change="categories_checked_change( i.id)">
                {{ i.name }}
              </div>

              <div class="right grey-label">
                {{ categories_count[ i.id] + " 社"}}
              </div>

            </div>
          </div>

        </div>
      </div>

      <!-- sub_categories select -->
      <div class="row" style="margin-top: 20px"
          v-for="categoryId in data.categories_checked_ids"
          :key="categoryId">

        <hr>
        <label>{{ categories_names[categoryId] }}</label>

        <div class="grid-container" style="background-color: #f9f9f9;">
          <div class="grid-item"
              v-for="subCategoryId in data.sub_category_maps[categoryId]"
              :key="subCategoryId">
            <input type="checkbox"
                  v-model="data.sub_categories_checked[subCategoryId]"
                  @change="sub_categories_checked_change"
                  style="margin-left: 20px; margin-right: 5px;">
            <label>{{ sub_categories_names[subCategoryId] }}</label>

            <span class="grey-label">{{ sub_categories_count[subCategoryId] }}</span>
          </div>
        </div>
      </div>

      <!-- 2 button-->
      <div class="row" style="margin-top: 20px;align-items: end">
        <div class="column" style="text-align: right">
          <button class="btn btn-primary" style="width: 80px"
                  @click="categories_modal_close">OK</button>

          <button class="btn btn-primary" style="width: 80px; margin-left: 30px"
                  @click="show_categories_modal = false">
            Cancel</button>
        </div>
      </div>

    </div>
  </div>
  <!-- end of categories_modal-->

  <!-- prefecture_modal -->
  <div v-if="show_prefecture_modal" class="modal-prefecture" :style="style" >
    <div class="modal-content">

      <!-- prefecture select table-->
      <div class="row" style="margin-top: 20px">

        <div class="grid-container-prefecture">
          <div v-for="i in prefecture_all" :key="i">
            <div class="flex-container">
              <div class="left-prefecture">
                <input type="checkbox" class="green-checkbox"
                       style="margin-left: 20px;margin-right: 5px;"
                       v-model="prefecture_checked[ i]"> {{ i}}
              </div>
            </div>
          </div>
        </div>

      </div>

      <!-- 2 button-->
      <div class="row" style="margin-top: 20px;align-items: end">
        <div class="column" style="text-align: right">
          <button class="btn btn-primary" style="width: 80px"
                  @click="prefecture_modal_close">OK</button>
          <button class="btn btn-primary" style="width: 80px; margin-left: 30px"
          @click="show_prefecture_modal = false">
            Cancel</button>
        </div>
      </div>

    </div>
  </div>
  <!-- end of prefecture_modal-->

  <!-- import_modal -->
  <div v-if="show_import_modal" class="modal-import" :style="style" >
    <div class="modal-content">

      <div class="row" style="margin-top: 20px">
        <h3>{{$t( "company_db.import_title")}}</h3>
      </div>

      <div class="row" style="margin-top: 20px">
        <table>
          <tbody>
            <tr>
              <td style="width: 100px; text-align: right">
                <label for="list_name">
                  {{$t( "company_db.import_list")}}:</label>
              </td>
              <td style="width: 100px">
                <select id="list_name" class="form-select" style="width: 200px; margin-left: 10px"
                v-model="sales_list_id_import">
                  <option v-for="i in sales_list_dict" :key="i.id" :value="i.id">
                    {{ i.name }}</option>
                </select>
              </td>
            </tr>

            <tr>
              <td style="width: 100px; text-align: right">
                <label for="import_count">
                  {{$t( "company_db.import_no")}}:</label>
              </td>
              <td style="width: 100px">
                <input type="text" id="import_count"
                      style="margin: 10px; width: 200px; text-align: left"
                v-model="companies_no_import">
              </td>
            </tr>

            <!-- message -->
            <tr>
              <td style="width: 100px; text-align: right">
                <label>{{$t( "company_db.message")}}:</label>
              </td>
              <td style="width: 150px;">
                <label style="margin-left: 10px; color: blue">
                  {{import_msg}}</label>
              </td>
            </tr>
          </tbody>
        </table>

      </div>

      <!-- 2 buttons -->
      <div class="row" style="margin-top: 20px;margin-left: 20px">
        <button class="btn btn-primary" style="width: 150px"
                @click="import_modal_begin">
          {{$t( "company_db.import_begin")}}</button>
        <button class="btn btn-primary" style="width: 80px; margin-left: 30px"
                @click="show_import_modal = false">
          Close</button>      </div>

    </div>
  </div>
  <!-- end of import_modal -->

  <div class="container" style="max-width: 1920px">

    <div class="row">
      <h3>{{$t( "company_db.h3")}}</h3>
    </div>

    <div class="row" style="margin-top: 20px">
      <table>
        <tdboy>
          <tr>
            <td style="width: 100px">
              <label for="categories">a.{{$t( "company_db.categories")}}:</label>
            </td>
            <td>
              <!-- todo: categories_view 內容太多，無法完整顯示 -->
              <input type="text" id="categories"
                    style="margin: 10px; width: 435px;background-color: rgb(245,247,249)"
                    v-model="categories_view" :readonly=true>
              <button class="btn btn-primary"
                      style="height: 24px;
                      font-size: 14px;
                      display: table-cell;
                      vertical-align: middle"
                      @click="show_categories_modal = true">...</button>
            </td>
          </tr>

          <tr>
            <td>
              <label for="prefecture">b.{{$t( "company_db.prefecture")}}:</label>
            </td>
            <td>
              <input type="text" id="prefecture"
                    style="margin: 10px; width: 435px; background-color: rgb(245,247,249)"
                    v-model="filter_prefecture" :readonly=true>
              <button class="btn btn-primary"
                      style="height: 24px;
                      font-size: 14px;
                      display: table-cell;
                      vertical-align: middle"
                      @click="show_prefecture_modal = true">...</button>
            </td>
          </tr>

          <tr>
            <td>
              <label for="capital_stock_min">c.{{$t( "company_db.capital_stock")}}:</label>
            </td>
            <td>
              <input type="text" id="capital_stock_min" style="margin: 10px; width: 200px"
                    @change="capital_stock_min_changed">
              <label> 〜 </label>
              <input type="text" id="capital_stock_max" style="margin: 10px; width: 200px"
                    @change="capital_stock_max_changed">
            </td>
          </tr>

          <tr>
            <td>
              <label for="amount_sales_min_changed">d.{{$t( "company_db.amount_sales")}}:</label>
            </td>
            <td>
              <input type="text" id="amount_sales_min_changed" style="margin: 10px; width: 200px"
                    @change="amount_sales_min_changed">
              <label> 〜 </label>
              <input type="text" id="amount_sales_max_changed" style="margin: 10px; width: 200px"
                    @change="amount_sales_max_changed">
            </td>
          </tr>

          <tr>
            <td>
              <label for="established_year_month_min">e.{{$t( "company_db.established_year_month_min")}}:</label>
            </td>
            <td>
              <input type="text" id="established_year_month_min" style="margin: 10px; width: 200px"
                    @change="established_year_month_min_changed">
              <label> 〜 </label>
              <input type="text" id="established_year_month_max" style="margin: 10px; width: 200px"
                    @change="established_year_month_max_changed">
            </td>
          </tr>

          <tr>
            <td>
              <label for="employee_number_min">f.{{$t( "company_db.employee_number")}}:</label>
            </td>
            <td>
              <input type="text" id="employee_number_min" style="margin: 10px; width: 200px"
                    @change="employee_number_min_changed">
              <label> 〜 </label>
              <input type="text" id="employee_number_max" style="margin: 10px; width: 200px"
                    @change="employee_number_max_changed">
            </td>
          </tr>

          <tr>
            <td>
              <label for="offices_number_min">g.{{$t( "company_db.offices_number")}}:</label>
            </td>
            <td>
              <input type="text" id="offices_number_min" style="margin: 10px; width: 200px"
                    @change="offices_number_min_changed">
              <label> 〜 </label>
              <input type="text" id="offices_number_max" style="margin: 10px; width: 200px"
                    @change="offices_number_max_changed">
            </td>
          </tr>

          <tr>
            <td>
              <label for="stores_number_min">h.{{$t( "company_db.stores_number")}}:</label>
            </td>
            <td>
              <input type="text" id="stores_number_min" style="margin: 10px; width: 200px"
                    @change="stores_number_min_changed">
              <label> 〜 </label>
              <input type="text" id="stores_number_max" style="margin: 10px; width: 200px"
                    @change="stores_number_max_changed">
            </td>
          </tr>

          <tr>
            <td>
              <label for="stock_market">i.{{$t( "company_db.stock_market")}}:</label>
            </td>
            <td>
              <select id="stock_market" class="form-select"
                      style="width: 200px; margin-left: 10px"
                      @change="stock_market_changed">

                <option value="*"> - </option>
                <option value="null">(空白)</option>

                <option value="東証プライム"   >{{$t( "company_db.stock_market_1")}}</option>
                <option value="東証スタンダード">{{$t( "company_db.stock_market_2")}}</option>
                <option value="東証グロース"   >{{$t( "company_db.stock_market_3")}}</option>

                <option value="名証プレミア">{{$t( "company_db.stock_market_4")}}</option>
                <option value="名証メイン"  >{{$t( "company_db.stock_market_5")}}</option>
                <option value="名証ネクスト">{{$t( "company_db.stock_market_6")}}</option>

                <option value="TOKYO PRO Market">TOKYO PRO Market</option>
                <option value="札幌証券取引所">{{$t( "company_db.stock_market_7")}}</option>
                <option value="アンビシャス"  >{{$t( "company_db.stock_market_8")}}</option>
                <option value="福岡証券取引所">{{$t( "company_db.stock_market_9")}}</option>
                <option value="Q-Board">Q-Board</option>

                <option value="未上場">{{$t( "company_db.stock_market_10")}}</option>
              </select>
            </td>
          </tr>
        </tdboy>
      </table>
    </div>

    <!-- 2 buttons-->
    <div class="row" style="margin-top: 20px">

      <!-- 絞り込み 縮小範圍-->
      <button class="btn btn-primary" style="padding: 0 50px; margin: 10px; width: 200px; height: 50px"
              @click="reload_data">{{$t( "company_db.filter_result")}}</button>

      <!-- 検索結果をインポート 導入搜尋結果: Show import to sales_list modal -->
      <button class="btn btn-primary" style="padding: 0 50px; margin: 10px; width: 350px; height: 50px"
         @click="open_import_modal">{{$t( "company_db.import_result")}}</button>

    </div>

    <div class="row" style="margin-top: 50px">
      <h4>{{$t( "company_db.f_title_0")}}
        ( {{ data.filtered_no }} {{$t( "company_db.f_title_1")}}
        {{ data.items.length }} {{$t( "company_db.f_title_2")}}
        )
      </h4>
    </div>

    <div class="row" style="margin-top: 20px">
      <table class="table table-hover">

        <thead>
        <tr>
          <th scope="col" style="width: 260px">{{$t( "company_db.company_name")}}</th>
          <th scope="col" style="width: 240px">{{$t( "company_db.company_url")}}</th>
          <th scope="col" style="width: 360px">a.{{$t( "company_db.categories")}}</th>
          <th scope="col" style="width: 180px">b.{{$t( "company_db.prefecture")}}</th>
          <th scope="col" style="width: 180px">e.{{$t( "company_db.established_year_month_min")}}</th>
          <th scope="col" style="width: 180px">{{$t( "company_db.representative_name")}}</th>
          <th scope="col" style="width: 200px">i.{{$t( "company_db.stock_market")}}</th>
          <th scope="col" style="width: 150px; text-align: right">c.{{$t( "company_db.capital_stock")}}</th>
          <th scope="col" style="width: 150px; text-align: right">d.{{$t( "company_db.amount_sales")}}</th>
          <th scope="col" style="width: 200px; text-align: right">f.{{$t( "company_db.employee_number")}}</th>
          <th></th>
        </tr>
        </thead>

        <tbody>
        <tr v-for="item in data.items" :key="item.id">

          <td>{{ item.company_name }}</td>
          <td style="max-width: 150px; word-break: break-all">{{ item.company_url }}</td>

          <td v-html="get_categories_names( item.categories)"></td>

          <td>{{ item.prefecture }}</td>
          <td>{{ item.established_year_month }}</td>
          <td>{{ item.representative_name }}</td>
          <td>{{ item.stock_market }}</td>
          <td style="text-align: right">{{ f_int(item.capital_stock) }}</td>
          <td style="text-align: right">{{ f_int(item.amount_sales) }}</td>
          <td style="text-align: right">{{ item.employee_number }}</td>

          <td>
            <button class="btn btn-primary" style="width: 100px"
                    @click="item_detail( item)">
              詳細</button>
          </td>
        </tr>
        </tbody>

      </table>

    </div>

  </div>

</template>

<style scoped>

  .grid-container {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    //grid-template-rows: 1fr 1fr; /* 兩行，等高 */
    //gap: 10px; /* 行列之間的間距 */
  }

  .grid-container-prefecture {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  }
  .left-prefecture {
    flex: 1; /* 左側部分 */
    width: 150px;
    margin-top: 15px;
  }
  .grid-item {
    //background-color: lightgrey;
    //padding: 20px;
    //text-align: center;
    //border: 1px solid #000;
  }

  .flex-container {
    display: flex;
    justify-content: space-between; /* 左右兩側對齊 */
  }
  .left {
    //margin-left: 20px;
    flex: 1; /* 左側部分 */
    width: 250px;
    //border: 1px solid black; /* 設置表格、表頭和單元格的邊框 */
    margin-top: 15px;
  }
  .right {
    margin-right: 30px;
    flex: 1; /* 右側部分 */
    text-align: right; /* 右側內容右對齊 */
    max-width: 100px;
    //border: 1px solid black; /* 設置表格、表頭和單元格的邊框 */
    margin-top: 15px;
  }

  .modal-categories {
    height: 800px;
    max-height: 1024px;
    width: 1600px;

    display: flex;
    justify-content: center;
    align-items: center;
    //position: fixed;

    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1000; /* 他の要素より前面に */
  }

  .modal-prefecture {
    height: 800px;
    max-height: 1024px;
    width: 920px;

    display: flex;
    justify-content: center;
    align-items: center;
    //position: fixed;

    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1000; /* 他の要素より前面に */
  }

  .modal-import {
    height: 800px;
    max-height: 1024px;
    width: 600px;

    display: flex;
    justify-content: center;
    align-items: center;
    //position: fixed;

    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1000; /* 他の要素より前面に */
  }

  .modal-header {
    cursor: pointer;
  }

  .modal-content {
    background-color: #fff;
    padding: 20px;
    border-radius: 5px;

    //width: 100%;  /* お好みに合わせて変更 */
    //height: 100%;

    max-width: 1600px;  /* お好みに合わせて変更 */
    //max-height: 1024px;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  }

  .grey-label {
    background-color: rgb( 195, 195, 195); /* 設置背景色 */
    height: 25px;
    font-size: 14px;
    padding: 5px; /* 添加內邊距以提高可讀性 */
    border-radius: 3px; /* 可選：添加圓角效果 */
    color: white; /* 設置文字顏色 */
  }

</style>